<template>
<div class="check-inventory">
    <div class="main-content-full">
        <div class="controller-container">
            <div class="controller-content">
                <el-select class="action-select-first" @change="selectOilClassIndex" v-model="oilClassIndex" placeholder="全部分类">
                    <el-option v-for="(item, index) in oilClassArr" :key="index" :label="item.name" :value="index">
                    </el-option>
                </el-select>
                <el-button type="primary" class="action-select-inventory" @click="newCheck">新 建</el-button>
            </div>
        </div>
        <div class="table-container">
            <el-table :data="tableData" style="width: 100%" :header-cell-style="changeTableHeaderStyle" :cell-style="changeTableStyle">
                 <el-table-column align="center" prop="stocking_number" label="盘点数量" min-width="17.5%">
                </el-table-column>
                <el-table-column align="center"  label="商品图片" width="180">
                    <template slot-scope="scope">
                        <img :src="scope.row.good_picture" height="80" width="72" alt="">
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="good_name" label="商品名称" min-width="30%">
                </el-table-column>
                <el-table-column align="center" prop="belong_warehouse" label="所属仓库" min-width="17.5%">
                </el-table-column>
                <el-table-column align="center" prop="system_number" label="系统数量" min-width="17.5%">
                </el-table-column>
               
            </el-table>
        </div>
    </div>
    <el-dialog class="dialog" title="新增盘点" :visible.sync="dialogFormVisible">
        <el-form :model="newCheckForm">
            <el-form-item label="选择仓库" :label-width="formLabelWidth">
                <el-select v-model="warehouseIndex" placeholder="请输入入库仓库">
                    <el-option v-for="(item, index) in warehouseArr" :key="index" :label="item.warehouse_name" :value="index"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="选择商品" :label-width="formLabelWidth">
                <el-select v-model="goodsIndex" placeholder="请输入入库仓库" @change="selectGoods">
                    <el-option v-for="(item, index) in goodsArr" :key="index" :label="item.name" :value="index"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="系统库存" :label-width="formLabelWidth">
                <!-- <el-input v-model="newCheckForm.numbers" autocomplete="off"></el-input> -->
                <span>{{newCheckForm.system_number}}</span>
            </el-form-item>
            <el-form-item label="盘点库存" :label-width="formLabelWidth">
                <el-input v-model="newCheckForm.stocking_number" autocomplete="off"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="newCheckQuit">取 消</el-button>
            <el-button type="primary" @click="newCheckOk">确 定</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import Tool from '../../assets/js/Tool.js';
import {
    mapGetters,
    mapMutations
} from 'vuex';
export default {
    data() {
        return {
            tableData: [],
            newCheckForm: {
                good_id: '',
                warehouse_id: '',
                stocking_number: '',
                system_number: 0,
            },
            goodsOptions: [],
            goodsSelectedOptions: [],
            warehouseArr: [],
            warehouseIndex: '',
            goodsArr: [],
            goodsIndex: '',
            oilClassArr: [],
            oilClassIndex: '',
            dialogFormVisible: false,
            formLabelWidth: '120px'
        }
    },
    computed: {
        ...mapGetters(['user', 'userTypeNum'])
    },
    created() {
        this.init();
    },
    methods: {
        changeTableHeaderStyle({
            row,
            rowIndex
        }) {
            return 'color:black; font-weight: bold;';
        },
        changeTableStyle({
            row,
            column,
            rowIndex,
            columnIndex
        }) {
            if (columnIndex == 5) {
                if (row.status_num == -1) {
                    return 'color: #FF3333;'
                } else if (row.status_num == 0) {
                    return 'color: #29bd7f;'
                } else if (row.status_num == 1) {
                    return 'color: #e6a23c;'
                }
            }
            return 'color: #000;'
        },
        init() {
            this.axios.get('get_classification')
            .then(res => {
                this.oilClassArr = res.data.data;
                this.getGoodsRepertory(0);
            })
        },
        // 请求商品库存
        getGoodsRepertory(class_id) {
            this.axios.get('stocking', {
                params: {
                    class_id: class_id,
                    user_id: this.user.id
                }
            })
            .then(res => {
                this.tableData = res.data.data;
            })
        },
        // 根据商品分类请求商品库存信息
        selectOilClassIndex() {
            alert(this.oilClassArr[this.oilClassIndex].id);
            this.getGoodsRepertory(this.oilClassArr[this.oilClassIndex].id);
        },
        getGoodsMenu() {
            this.axios.get('obtain_warehouse_info', {
                params: {
                    warehouse_id: 59
                }
            })
            .then(res => {
                this.goodsArr = res.data.data;
            })
        },
        getWarehouseMenu() {
            this.axios.get('getwarehouse', {
                params: {
                    user_id: this.user.id,
                    type: 1
                }
            })
            .then(res => {
                this.warehouseArr = res.data.data;
            })
        },
        // 新建入库单
        newCheck() {
            this.getGoodsMenu();
            this.getWarehouseMenu();
            this.dialogFormVisible = true;
        },
        newCheckOk() {
            this.newCheckForm.stocking_number = parseFloat(this.newCheckForm.stocking_number);
            this.newCheckForm.good_id = this.goodsArr[this.goodsIndex].id;
            
            let sendObj = {
                inventory_id: this.newCheckForm.good_id,
                number: this.newCheckForm.stocking_number,
                user_id: this.user.id,
            };
            
            this.axios.post('stocking', JSON.stringify(sendObj))
            .then(res => {
                this.dialogFormVisible = false;
                this.$message({
                    type: 'success',
                    message: res.data.msg
                });
            })
        },
        newCheckQuit() {
            this.newCheckForm.system_number = '';
            this.newCheckForm.stocking_number = '';
            this.dialogFormVisible = false;
        },
        // 选择商品
        selectGoods() {
            this.newCheckForm.system_number = this.goodsArr[this.goodsIndex].current_nums;
        }
    }
}
</script>

<style scoped>
@import url(../../assets/css/base.css);

.check-inventory {
    background-color: #F9F9F9;
}

.action-select-first,
.action-select-inventory {
    margin-left: 24px;
    width: 100px;
}

.action-select-first {
    margin-left: 0px;
    width: 161px;
}

.controller-container {
    background-color: #d2f5e8;
}

.controller-content {
    margin: 0 auto;
    width: 1290px;
    padding-top: 13px;
}
</style>



// WEBPACK FOOTER //
// src/pages/inventoryManage/CheckInventory.vue